export const serverURL = "https://v2.sellingcommunity.com";
// export const serverURL = "http://127.0.0.1";
export const socketURL = "ws://3.9.199.189";
export const debuggerURL = "127.0.0.1";
export const portNumber = 443;
